import React from 'react';
import useStyle from './myRankingBlock.style';
import { MyRank } from '../../../organisms/Features/FeatureMyRank';

export const MyRankingBlock = ({ rank, name }: MyRank) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <p className={classes.text}>{name}</p>
      <p className={classes.position}>
        {rank}
        {rank === 1 ? ' er(e)' : ' ème'}
      </p>
    </div>
  );
};
